import React, { Fragment, useEffect } from "react";
import "./SideMenu.scss";
import { cLogo, LogoImg2 } from "assets/images";
import { NavLink } from "react-router-dom";
import { MdContentCopy, MdDashboard, MdHeadsetMic, MdSupervisorAccount } from "react-icons/md";
import ExtensionIcon from '@mui/icons-material/Extension';
import ArticleIcon from '@mui/icons-material/Article';
import useUser from "hooks/useUser";
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import PaymentIcon from '@mui/icons-material/Payment';
import FeedbackIcon from '@mui/icons-material/Feedback';

const checkPermission = (user, module) => {

  if (user?.role?.name?.includes("SUPER_ADMIN")) {
    return true
  }

  switch (module) {
    case "DASHBOARD":
      return ["dashboard.read"].some(per => user?.role?.resources?.includes(per));
    case "USER-MANAGEMENT":
      return ["user.read"].some(per => user?.role?.resources?.includes(per));
    case "RECIPE":
      return ["recipe.read"].some(per => user?.role?.resources?.includes(per));
    case "ARTICLE":
      return ["article.read"].some(per => user?.role?.resources?.includes(per));
    case "CONTENT":
      return ["content.read"].some(per => user?.role?.resources?.includes(per));
    case "SUBSCRIPTION":
      return ["subscription.read"].some(per => user?.role?.resources?.includes(per));
    case "ACTIVITY":
      return ["activity.read"].some(per => user?.role?.resources?.includes(per));
    case "REPORT":
      return ["report.read"].some(per => user?.role?.resources?.includes(per));
    default:
      return false
  }
};

const SideMenu = () => {
  const { user } = useUser();

  const sideMenuData = [
    {
      id: 1001,
      enabled: checkPermission(user, "DASHBOARD"),
      path: "/dashboard",
      name: "Dashboard",
      icon: <MdDashboard />,
    },
    {
      id: 1002,
      enabled: checkPermission(user, "USER-MANAGEMENT"),
      path: "/user-management",
      name: "User Management",
      icon: <MdSupervisorAccount />,
    },
    {
      id: 1002,
      enabled: checkPermission(user, "SUPER-ADMIN"),
      path: "/personal-details",
      name: "Sub-Admin management",
      icon: <MdSupervisorAccount />,
    },
    {
      id: 1005,
      enabled: checkPermission(user, "CONTENT"),
      path: "/content-management",
      name: "Content Management",
      icon: <MdContentCopy />,
    },
    {
      id: 1006,
      enabled: checkPermission(user, "FEEDBACK"),
      path: "/feedback-management",
      name: "Feedback Management",
      icon: <MdHeadsetMic />,
    },
    {
      id: 1007,
      enabled: checkPermission(user, "ACTIVITY"),
      path: "/activity-management",
      name: "Activity Management",
      icon: <ExtensionIcon />,
    },
    {
      id: 1008,
      enabled: checkPermission(user, "ARTICLE"),
      path: "/article-management",
      name: "Article Management",
      icon: <ArticleIcon />,
    },
    {
      id: 1008,
      enabled: checkPermission(user, "RECIPE"),
      path: "/recipe-management",
      name: "Recipe Management",
      icon: <OutdoorGrillIcon />,
    },
    {
      id: 1008,
      enabled: checkPermission(user, "SUBSCRIPTION"),
      path: "/subscription-management",
      name: "Subscription Management",
      icon: <PaymentIcon />,
    },
    {
      id: 1009,
      enabled: checkPermission(user, "REPORT"),
      path: "/report-management",
      name: "Manage Report",
      icon: <FeedbackIcon />,
    },
  ].filter((data) => data.enabled);

  return (
    <>
      <aside className="aside">
        <div className="logo">
          <img src={LogoImg2} alt="Organization name"  />
          {/* <h5>Free Gurukul Education Foundation</h5> */}
        </div>
        <div className="side_menu">
          <ul>
            {sideMenuData &&
              sideMenuData.map(({ id, path, name, icon }) => (
                <li key={id}>
                  <NavLink to={path}>
                    <span>{name}</span>
                    {icon}
                  </NavLink>
                </li>
              ))}
          </ul>
        </div>
      </aside>
    </>
  );
};

export default SideMenu;
